import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "@nextui-org/react";
import { apigetallCurrentaffairs } from "../../../admin/shared/services/apiCurrentaffairs/apicurrentaffairs";

export default function MonthlyCurrentAffairs() {
    const [loading, setLoading] = useState(true);
    const [monthlyData, setMonthlyData] = useState({});
    const navigate = useNavigate();

    const fetchAllAffairs = useCallback(async () => {
        setLoading(true);
        try {
            const res = await apigetallCurrentaffairs({ first: 0, rows: 1000 });
            const data = res?.resdata || [];
            
            const groupedByMonth = {};
            data.forEach(item => {
                const date = new Date(item.createdAt);
                const monthYear = `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
                
                if (!groupedByMonth[monthYear]) {
                    groupedByMonth[monthYear] = [];
                }
                groupedByMonth[monthYear].push(item);
            });
            
            setMonthlyData(groupedByMonth);
        } catch (error) {
            console.error('Error fetching affairs:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAllAffairs();
    }, [fetchAllAffairs]);

    const handleMonthSelect = (month) => {
        const encodedMonth = encodeURIComponent(month);
        navigate(`/monthly-current-affairs/${encodedMonth}`);
    };

    return (
        <>
            <div className="max-w-[85rem] mx-auto py-5 px-4">
                <div className="flex items-center mb-6">
                    <Link to="/current-affairs" className="mr-4">
                        <svg className="text-gray-600 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m15 18-6-6 6-6"/>
                        </svg>
                    </Link>
                    <h1 className="text-3xl font-bold">Monthly Current Affairs</h1>
                </div>

                {loading ? (
                    <div className="flex items-center justify-center h-40">
                        <Spinner size="lg" color="primary" className="text-blue-500" />
                    </div>
                ) : Object.keys(monthlyData).length === 0 ? (
                    <div className="p-4 text-center bg-gray-100 rounded-lg">
                        <p>No monthly current affairs available</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                        {Object.keys(monthlyData).sort((a, b) => {
                            const dateA = new Date(a);
                            const dateB = new Date(b);
                            return dateB - dateA;
                        }).map((month) => (
                            <div key={month} className="flex flex-col gap-2 p-4 transition-all duration-300 border-2 border-gray-200 rounded-lg cursor-pointer hover:shadow-md hover:border-regal-blue" onClick={() => handleMonthSelect(month)}>
                                <div className="flex items-center justify-center w-24 h-24 mx-auto text-gray-700 rounded-full bg-regal-yellow">
                                    <p className="text-xl font-semibold text-center">{month}</p>
                                </div>
                                <p className="mt-2 text-center text-gray-600">{monthlyData[month].length} affairs</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}